<template>
    <div class="form-group" :class="theClasses">
        <label v-if="!!label" for>
            {{ label }}
            <span v-if="!!required" class="field-required-mark">*</span>
        </label>
        <textarea
            :name="name"
            :id="id"
            :rows="rows"
            :readonly="readonly"
            class="form-control"
            :value="value"
            @input="$emit('input', $event.target.value)"
            @change="$emit('change', $event.target.value)"
            @blur="$emit('blur', $event)"
        ></textarea>
        <span v-if="hasError" class="field-error">{{ errorMessage }}</span>
    </div>
</template>
<script>
export default {
    props: {
        label: {
            default: '',
        },
        name: {
            default: () => `textarea-${parseInt(Math.random() * 100000000)}`,
        },
        id: {
            default: () => `textarea-${parseInt(Math.random() * 100000000)}`,
        },
        rows: {
            default: 4,
        },
        value: {
            default: '',
        },
        autofocus: {
            default: false,
        },
        classes: {
            default: '',
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        readonly: {
            default: false,
        },
    },
    computed: {
        theClasses() {
            if (typeof this.classes === 'string') {
                const classes = {}
                classes[this.classes] = 1
                return classes
            }

            if (Array.isArray(this.classes)) {
                const classes = {}
                this.classes.map(theClass => (classes[theClass] = 1))
                return classes
            }

            if (
                this.classes &&
                typeof this.classes === 'object' &&
                this.classes.constructor === Object
            ) {
                return this.classes
            }
        },
    },
    mounted() {
        if (this.autofocus) {
            $(`#${this.id}`).focus()
        }
    },
}
</script>
